// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"549":"ec73f91a","601":"ec73f91a","728":"7a33a917"}[chunkId] + ".chunk.css";
};